import { GO_SHARE_COMPANY_IDS, COMPANY_BRANDING_ENABLED_IN_PRODUCTION } from "Constants";
import { BrandCustom } from "../models/brand.custom";

export const GOV_LOG_BRAND: BrandCustom = {
  primaryColor: "#FBB040",
  hoverColor: "#CC8F32",
  pressedColor: "#B27D2C",
  disabledColor: "#F8EEE0",
  darkPrimaryColor: "#664819",
  headerBackgroundColor: "#fbf2e4",
  subHeaderBackgroundColor: "#FAFAFA",
  enableCustomLogo: true,
};

export const getBrandByCompanyName = (companyId: number) => {
  const isProduction = process.env.NODE_DATABASE === "production";

  if (isProduction) {
    if (COMPANY_BRANDING_ENABLED_IN_PRODUCTION.includes(companyId)) return GOV_LOG_BRAND;

    return undefined;
  }

  if (GO_SHARE_COMPANY_IDS.includes(companyId)) return GOV_LOG_BRAND;
  return undefined;
};
